//HACK the animated data uri svg cursors doesn't refresh in chrome without this

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = fixCursorStyle;

var _reactDom = require('react-dom');

/**
 * ref - mounted react component or DOM element
 * cursor - string
*/

function fixCursorStyle(ref, cursor) {
  var node = (0, _reactDom.findDOMNode)(ref);
  node.style.cursor = 'default';
  node.style.cursor = cursor;
}

module.exports = exports['default'];
//# sourceMappingURL=fixCursorStyle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/transhand/lib/fixCursorStyle.js
 ** module id = 331
 ** module chunks = 0
 **/